import * as actionType from './action-type'
import initialState from './initial-state'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionType.SET_LINK_TYPE:
      return {
        ...state,
        type: payload.type
      }
    case actionType.SET_LINK_METRIC:
      return {
        ...state,
        metric: payload.metric
      }
    case actionType.SET_LINK_DATASETS:
      return {
        ...state,
        datasets: payload.datasets
      }
    default:
      return state
  }
}
